import { render } from "./EvaluationForm.vue?vue&type=template&id=1665101c"
import script from "./EvaluationForm.vue?vue&type=script&lang=js"
export * from "./EvaluationForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/localhrm.apcwo.org/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__